/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";

export const PurchaseOrders: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">

                {/* Query List Here */}
                <QueryListProvider>
                    <QueryList 
                        listTitle={"PPOs"}
                        recordTitle={"PPO"}
                        tableName={"sa_ppo_header"} 
                        editTableName={"sa_ppo_header"}
                        editHasCompoundKey={false}
                        join={[
                            {
                                "relationship": "vendor",
                                "joinType": "LEFT"
                            }
                        ]} 
                        select={[                                                        
                            {
                                fullColumnName : "ppo_num",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "vendor.co_name",
                                aggregate: ""
                            },                              
                            {
                                fullColumnName : "po_date",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "ship_date",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "amount",
                                aggregate: ""
                            },                                                                                                                               
                            {
                                fullColumnName : "vendor.terms",
                                aggregate: ""
                            }
                        ]}
                        where={[]} 
                        orderBy={[    
                            {
                                fullColumnName: "po_date",
                                direction: "DESC",
                                cast: CastType.DATE
                            },
                            {
                                fullColumnName: "ppo_num",
                                direction: "DESC",
                                cast: CastType.STRING
                            }                            
                        ]} 
                        groupBy={[]}                    
                    />
                </QueryListProvider> 
            </Container>
        </React.Fragment>
    );
}